import { serverResponse } from 'app'

import * as actions from '../actions'

export const getInitialState = serverResponse

export default (state = getInitialState(), action = {}) => {
  switch (action.type) {
    case actions.PL_PLAYER_FETCH: {
      return serverResponse(state, { key: action.payload.playerId, loading: true })
    }
    case actions.PL_PLAYER_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.PL_PLAYER_FETCH_ERROR: {
      return serverResponse(state, action.payload)
    }
    case actions.PL_PLAYER_FETCH_FULFILLED: {
      return serverResponse(state, action.payload)
    }
    case actions.PL_PLAYER_RESET: {
      return getInitialState()
    }

    default:
  }
  return state
}
